import { combineReducers } from 'redux';
import { persistReducer } from 'redux-persist';
import storage from 'redux-persist/es/storage';

import adminsReducer from 'app/ducks/admins/reducer';
import authenticationReducer from 'app/ducks/authentication/reducer';
import bankAccountsReducer from 'app/ducks/bankAccounts/reducer';
import bulkImportsReducer from 'app/ducks/bulkImports/reducer';
import connectReducer from 'app/ducks/connect/reducer';
import connectionsReducer from 'app/ducks/connections/reducer';
import connectionRunsReducer from 'app/ducks/connectionRuns/reducer';
import connectionTypesReducer from 'app/ducks/connectionTypes/reducer';
import competitionsReducer from 'app/ducks/competitions/reducer';
import creditCardsReducer from 'app/ducks/creditCards/reducer';
import dataImportsReducer from 'app/ducks/dataImports/reducer';
import globalReducer from 'app/ducks/global/reducer';
import groupImportsReducer from 'app/ducks/groupImports/reducer';
import groupsReducer from 'app/ducks/groups/reducer';
import invitationsReducer from 'app/ducks/invitations/reducer';
import matchPaymentsReducer from 'app/ducks/matchPayments/reducer';
import refundsReducer from 'app/ducks/refunds/reducer';
import loadingReducer from 'app/ducks/loading/reducer';
import onBoardingReducer from 'app/ducks/onboarding/reducer';
import orgCustomersReducer from 'app/ducks/orgCustomers/reducer';
import orgTeamsReducer from 'app/ducks/orgTeams/reducer';
import organisationAddressesReducer from 'app/ducks/organisationAddresses/reducer';
import organisationSectionsReducer from 'app/ducks/organisationSections/reducer';
import organisationsReducer from 'app/ducks/organisations/reducer';
import organisationFeesReducer from 'app/ducks/organisationFees/reducer';
import organisationTagsReducer from 'app/ducks/organisationTags/reducer';
import notificationConfigsReducer from 'app/ducks/notificationConfigs/reducer';
import paymentCollectionsReducer from 'app/ducks/paymentCollections/reducer';
import paymentEventDashboardReducer from 'app/ducks/paymentEventDashboard/reducer';
import paymentEventImportsReducer from 'app/ducks/paymentEventImports/reducer';
import paymentEventsReducer from 'app/ducks/paymentEvents/reducer';
import paymentRequestsReducer from 'app/ducks/paymentRequests/reducer';
import fixtureMatchImportsReducer from 'app/ducks/fixtureMatchImports/reducer';
import fixtureMatchesReducer from 'app/ducks/fixtureMatches/reducer';
import paymentRecordsReducer from 'app/ducks/paymentRecords/reducer';
import paymentsReducer from 'app/ducks/payments/reducer';
import paymentTagsReducer from 'app/ducks/paymentTags/reducer';
import peopleReducer from 'app/ducks/people/reducer';
import purchasesReducer from 'app/ducks/purchases/reducer';
import forfeitsReducer from 'app/ducks/forfeits/reducer';
import reportsReducer from 'app/ducks/reports/reducer';
import subscriptionPaymentsReducer from 'app/ducks/subscriptionPayments/reducer';
import stripeSessionsReducer from 'app/ducks/stripeSessions/reducer';
import organisationProductsReducer from 'app/ducks/organisationProducts/reducer';
import organisationSubscriptionsReducer from 'app/ducks/organisationSubscriptions/reducer';

import { AuthenticationActionTypes } from 'app/ducks/authentication/types';

const config = {
  key: 'primary',
  storage,
  whitelist: ['paymentEventDashboard', 'authentication', 'onBoarding', 'connect'],
};

const appReducer = persistReducer(
  config,
  combineReducers({
    admins: adminsReducer,
    authentication: authenticationReducer,
    bankAccounts: bankAccountsReducer,
    bulkImports: bulkImportsReducer,
    competitions: competitionsReducer,
    connect: connectReducer,
    connectionRuns: connectionRunsReducer,
    connections: connectionsReducer,
    connectionTypes: connectionTypesReducer,
    creditCards: creditCardsReducer,
    dataImports: dataImportsReducer,
    fixtureMatches: fixtureMatchesReducer,
    fixtureMatchImports: fixtureMatchImportsReducer,
    forfeits: forfeitsReducer,
    global: globalReducer,
    groupImports: groupImportsReducer,
    groups: groupsReducer,
    invitations: invitationsReducer,
    loading: loadingReducer,
    matchPayments: matchPaymentsReducer,
    refunds: refundsReducer,
    notificationConfigs: notificationConfigsReducer,
    onBoarding: onBoardingReducer,
    organisationAddresses: organisationAddressesReducer,
    organisationFees: organisationFeesReducer,
    organisations: organisationsReducer,
    organisationSections: organisationSectionsReducer,
    organisationTags: organisationTagsReducer,
    orgCustomers: orgCustomersReducer,
    orgTeams: orgTeamsReducer,
    paymentCollections: paymentCollectionsReducer,
    paymentEventDashboard: paymentEventDashboardReducer,
    paymentEventImports: paymentEventImportsReducer,
    paymentEvents: paymentEventsReducer,
    paymentRecords: paymentRecordsReducer,
    paymentRequests: paymentRequestsReducer,
    payments: paymentsReducer,
    paymentTags: paymentTagsReducer,
    people: peopleReducer,
    purchases: purchasesReducer,
    reports: reportsReducer,
    subscriptionPayments: subscriptionPaymentsReducer,
    stripeSessions: stripeSessionsReducer,
    organisationProducts: organisationProductsReducer,
    organisationSubscriptions: organisationSubscriptionsReducer,
  }),
);

export default (state, action) => {
  if (action.type === AuthenticationActionTypes.USER_LOGOUT) {
    state = undefined; // eslint-disable-line no-param-reassign
    storage.removeItem('persist:primary').then(() => {});
  }
  // if(action.type === 'persist/REHYDRATE') {  state = action.payload  }

  return appReducer(state, action);
};
